import * as S from "./ExercisePartItem.style";
import { Video } from "@/common/types/video";
import { exercisePartCategory } from "@/data/category";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_rt.svg";

interface ExercisePartItemProps {
  video: Video;
  onClick: (videoId: string) => void;
}

export const ExercisePartItem = ({ video, onClick }: ExercisePartItemProps) => {
  const categoryLabel =
    exercisePartCategory.find((cat) => cat.id === video.category)?.title || "";

  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds}초`;
    }

    return remainingSeconds > 0
      ? `${minutes}분 ${remainingSeconds}초`
      : `${minutes}분`;
  };

  return (
    <S.ExercisePartItem onClick={() => onClick(video?.id)}>
      <S.ItemTitBox>
        <S.ItemImgBox>
          <img src={video.thumbnailUrl} alt={video.title} />
        </S.ItemImgBox>
        <S.ItemTit>
          <div className="textUpperBox">
            <span>{categoryLabel}</span> |
            <p>{formatDuration(video.duration || 0)}</p>
          </div>
          {video.title}
        </S.ItemTit>
      </S.ItemTitBox>

      <S.ItemArrow>
        <IconArrow width={30} height={30} />
      </S.ItemArrow>
    </S.ExercisePartItem>
  );
};
